import dayjs from "dayjs";
import {EntityBase} from "../../../shared/entity/EntityBase";

const POPUP_MASTER_FIELDS = {
    seq: { type: Number, defaultValue: 0 },
    index: { type: Number, defaultValue: 0 },
    name: { defaultValue: '' },
    openLevel: { type: Number, defaultValue: 1 },
    onOff: { type: Number, defaultValue: 0 },
    begin: { type: Number, defaultValue: dayjs().hour(9).startOf('hour').unix() },
    end: { type: Number, defaultValue: dayjs().add(1, 'day').hour(8).endOf('hour').unix() },
    memo: { defaultValue: '' },
}

export class PopupMasterEntity extends EntityBase {
    constructor(data = {}) {
        super(data, POPUP_MASTER_FIELDS);

        this.errors = [
            {condition: () => this.index === 0, message: "인덱스를 입력해주세요."},
            {condition: () => this.begin >= this.end, message: "종료일은 시작일보다 커야합니다."},
        ]
    }
}